/*
 * Copyright © 2018, Rezo Zero
 *
 * @file BootstrapMedia.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import {
    Utils
} from 'starting-blocks'

/**
 * Static class to get bootstrap breakpoints.
 */
export default class BootstrapMedia {
    /**
     * Test if viewport width in greater or equal than bootstrap XS breakpoint (544px).
     *
     * @return {Boolean}
     */
    static isMinXS () {
        const size = Utils.getViewportSize()
        return size.width >= 576
    }

    /**
     * Test if viewport width in greater or equal than bootstrap SM breakpoint (768px).
     *
     * @return {Boolean}
     */
    static isMinSM () {
        const size = Utils.getViewportSize()
        return size.width >= 768
    }

    /**
     * Test if viewport width in greater or equal than bootstrap MD breakpoint (992px).
     *
     * @return {Boolean}
     */
    static isMinMD () {
        const size = Utils.getViewportSize()
        return size.width >= 1200
    }

    /**
     * Test if viewport width in greater or equal than bootstrap LG breakpoint (1440px).
     *
     * @return {Boolean}
     */
    static isMinLG () {
        const size = Utils.getViewportSize()
        return size.width >= 1440
    }

    /**
     * Test if viewport width in greater or equal than bootstrap XL breakpoint (2000px).
     *
     * @return {Boolean}
     */
    static isMinXL () {
        const size = Utils.getViewportSize()
        return size.width >= 2000
    }
}



// WEBPACK FOOTER //
// ./webpack/js/utils/BootstrapMedia.js